import React from "react";
import PropTypes from "prop-types";
import { MasterSidebar } from "../../../../components/Common";

/**
 * RoleSidebar
 * Listagem lateral dos cargos utilizando o componente padronizado MasterSidebar.
 */
const RoleSidebar = ({ roles, activeId, onSelect, onCreateNew, loading }) => {

    // Renderização customizada de cada item do cargo
    const renderRoleItem = (role, isActive) => (
        <div className="text-start w-100 overflow-hidden">
            <div className="d-flex align-items-center justify-content-between">
                <p className={`mb-0 fw-semibold text-truncate ${isActive ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '13.5px' }}>
                    {role.name}
                </p>
                {role.status === 'inactive' && (
                    <i className="mdi mdi-eye-off-outline text-muted" style={{ fontSize: '14px' }} title="Inativo"></i>
                )}
            </div>
            <span className="text-muted small text-truncate d-block mt-1" style={{ fontSize: '11px', opacity: 0.8 }}>
                {role.description || "Sem descrição"}
            </span>
        </div>
    );

    return (
        <MasterSidebar
            title="Cargos"
            subtitle="Permissões e acessos"
            items={roles}
            activeId={activeId}
            onSelect={onSelect}
            onCreateNew={onCreateNew}
            loading={loading}
            searchPlaceholder="Buscar cargo..."
            icon="mdi mdi-account-cog"
            renderItem={renderRoleItem}
            loadingMessage="Carregando cargos e permissões..."
        />
    );
};

RoleSidebar.propTypes = {
    roles: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default RoleSidebar;
